var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "currentColor", fillRule: "evenodd" },
            React.createElement("path", { d: "M15.373 13.153l2.561 2.159 3.194-.882a.5.5 0 01.6.661l-1.202 3.139 1.862 2.823a.5.5 0 01-.453.774l-3.3-.239-2.029 2.612a.5.5 0 01-.878-.181l-.853-3.273-3.137-1.207a.5.5 0 01-.09-.888l2.793-1.784.11-3.348a.5.5 0 01.822-.366zM34.12 15.389l3.41 3.184a1.435 1.435 0 010 2.125l-3.41 3.185c-1.2 1.117-1.57 1.629-2.254 1.313-.61-.281-.489-1.198-.489-2.375v-1.23a6.58 6.58 0 00-5.608 6.507 1.884 1.884 0 01-3.769 0c0-5.388 4.117-9.813 9.377-10.302V16.45c0-1.186-.138-2.096.497-2.376.713-.318 1.054.203 2.247 1.315z" }),
            React.createElement("path", { d: "M33 30a1 1 0 01.993.883L34 31v2.5a1.5 1.5 0 01-1.356 1.493L32.5 35h-17a1.5 1.5 0 01-1.493-1.356L14 33.5V31a1 1 0 011.993-.117L16 31v2h16v-2a1 1 0 01.883-.993L33 30z", fillRule: "nonzero" }))));
});
